import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import App from '../../components/App/App';
import PersonalLicenses from '../../components/PersonalLicenses/PersonalLicenses';
import UserProfileLayout from '../../components/layouts/UserProfileLayout';

const PersonalLicensesPage = () => {
  return (
    <App>
      <UserProfileLayout>
        <PersonalLicenses />
      </UserProfileLayout>
    </App>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default PersonalLicensesPage;
